var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, property } from 'lit-element';
import { html } from 'lit-html';
import render from './render';
import ViewTemplates from './index';
export default class LitView extends LitElement {
    constructor() {
        super(...arguments);
        this.value = null;
        this.templateScope = '';
        this.ignoreMissing = false;
        this.templateRegistry = '';
    }
    render() {
        if (this.value) {
            return render(ViewTemplates.byName(this.templateRegistry), { value: this.value, scope: this.templateScope }, this.ignoreMissing);
        }
        return html ``;
    }
}
__decorate([
    property({ type: Object, attribute: false })
], LitView.prototype, "value", void 0);
__decorate([
    property({ type: String, attribute: 'template-scope' })
], LitView.prototype, "templateScope", void 0);
__decorate([
    property({ type: Boolean, attribute: 'ignore-missing' })
], LitView.prototype, "ignoreMissing", void 0);
__decorate([
    property({ type: String, attribute: 'template-registry' })
], LitView.prototype, "templateRegistry", void 0);
window.customElements.define('lit-view', LitView);
//# sourceMappingURL=lit-view.js.map